<template>
    <div class="ppt-state2">
        <p class="title">
            <span class="name">{{title || '导入PPT'}}</span>
            <span
                @click="$emit('close')"
                class="close">x</span>
        </p>
        <div v-if="content" class="ppt-txt">
            <p>{{content}}</p>
        </div>
        <div v-else class="ppt-txt">
            <p class="rate">PPT导入中{{rate}}%</p>
            <p class="warn">(关闭窗口不影响ppt导入，导入完成会生成新的课件)</p>
        </div>
        <div class="btns">
            <el-button
                v-if="cancelName"
                class="btn"
                size="small"
                @click="cancel"
            >{{cancelName}}</el-button>
            <el-button
                v-if="submitName"
                class="btn"
                size="small"
                @click="submit"
            >{{submitName}}</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ppt-upload-status2",
        props: {
            title: String,
            content: String,
            cancelName: String,
            submitName: String,
            rate: [String, Number]
        },
        methods: {
            cancel(){
                this.$emit('cancel')
            },
            submit(){
                this.$emit('submit')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .ppt-state2{
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 420px;
        height: 220px;
        top: 46%;
        left: 50%;
        margin-left: -210px;
        margin-top: -110px;
        background: #FFFFFF;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        z-index: 100;

        .title{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 56px;
            line-height: 56px;
            border-bottom: 1px solid #E9E9E9;

            .name{
                margin-left: 24px;
            }
            .close {
                padding: 20px;
                cursor: pointer;
                color: #c1c1c1;
                font-size: 16px;
                user-select: none;
            }
        }
        .ppt-txt{
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .rate{
                font-size: 18px;
                font-family: Helvetica;
                color: #303133;
                line-height: 14px;
                margin-bottom: 22px;
            }
            .warn{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #606266;
                line-height: 20px;
            }
        }
        .btns{
            display: flex;
            flex-direction: row;
            justify-content: center;

            .btn{
                margin-bottom: 20px;
            }
        }
    }
</style>
